// extracted by mini-css-extract-plugin
export default {"commentBox":"qEdhy8"};